<template>
  <div class="header header-main">
    <div class="header-buttons">
      <ul>
        <li><a class="gray" @click="publish(socketTypes.sync)" href="javascript:;"><span v-lang.header.publish></span><i
        class="icon-open"></i></a>
        </li>
      </ul>
    </div>
    <div class="header-lng-select" v-if="(Object.keys(selectedLanguage).length > 0)">
            <span v-on-click-outside="close" :class="{selected:isOpenedLangBar}" v-on:click="changeLanguage()">
                <img :src="'/admin/' + selectedLanguage.imageName" :alt="selectedLanguage.altText"><i
            class="icon-arrow"></i>
            </span>
      <ul :class="{hide:!isOpenedLangBar}">
        <li v-for="lang in languages" :key="lang.id">
          <a v-on:click="changeLanguage(lang)">
            <img :src="'/admin/'+ lang.imageName" :alt="lang.altText">
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import MiddlewareService from '@/MiddlewareService.js';
import { changeLangBus } from '@/helpers/Bus';
import switchLang from '@/helpers/switchLanguage';
import NotificationsMixins from '@/components/mixins/notifications';
import getLangNameMixins from '@/components/mixins/langsName';
import socketMixin from '@/components/mixins/socket';
import CheckJsonString from '@/components/mixins/CheckJsonString';
import { socketTypes } from '@/helpers/Constants';

import { mixin as onClickOutside } from 'vue-on-click-outside';

const R = require('ramda');

export default {
  name: "header-component",
  data: function() {
    return {
      switchLang,
      storLang: localStorage.langType,
      mallId: localStorage.mallId,
      isOpenedLangBar: false,
      socketTypes
    };
  },
  mixins: [onClickOutside, NotificationsMixins, getLangNameMixins, socketMixin, CheckJsonString],
  computed: {
    languages() {
      return this.$store.state.languages;
    },
    selectedLanguage() {
      return this.$store.state.selectedLanguage;
    }
  },
  methods: {
    async publish(type) {
      const data = await MiddlewareService.processRequest(`/MallStation/${localStorage.mallId}`);
      if (data && data.body && data.body.message && data.body.success) {
        data.body.message.forEach(el => {
          this.sendMessage(JSON.stringify({
            toSocketId: {
              mallId: `${localStorage.mallId}`,
              stationId: `${el.areaId}`
            },
            fromSocketId: {
              mallId: `main`,
              stationId: `main`
            },
            message: type
          }));
        });
      }
    },
    sendMessage(message) {
      if (!this.isOpen(this.socket)) {
        if (this.socket && this.socket.readyState === this.socket.CLOSED) {
          this.connect("ws", `mallId=${localStorage.mallId}&stationId=${localStorage.stationId}`);
        }
      } else {
        this.socketSend(message);
      }
    },
    close() {
      this.isOpenedLangBar = false;
    },
    changeLanguage(selectedlanguage) {
      this.isOpenedLangBar = !this.isOpenedLangBar;
      if (selectedlanguage) {
        this.$store.commit('setSelectedLanguage', selectedlanguage);
        this.language = selectedlanguage.name;
        localStorage.lang = JSON.stringify(selectedlanguage);
        localStorage.langType = selectedlanguage.name;
        changeLangBus.$emit('changeLang');
      }
    }
  },
  async beforeMount() {
    if (localStorage.mallId && localStorage.mallId.length) {
      const data = await MiddlewareService.processRequest(`/Language?mallId=${localStorage.mallId}`);
      if (data && data.body && data.body.success) {
        const extenedLanguageArray = R.forEach(l => {
          l.altText = this.getName(l.name).name;
          l.imageName = this.getName(l.name).imageName;
        }, data.body.message);

        let selectedLang = R.filter(l => l.name === this.language, extenedLanguageArray)[0];
        if (!selectedLang && extenedLanguageArray.length > 0) {
          selectedLang = extenedLanguageArray[0];
        }
        if (!selectedLang) {
          this.showWarning({ message: 'There are no langs added to this mall' });
        } else {
          this.$store.commit('setLanguages', extenedLanguageArray);
          this.$store.commit('setSelectedLanguage', selectedLang);
          localStorage.lang = JSON.stringify(selectedLang);

          this.language = selectedLang.name;
          localStorage.langType = selectedLang.name;
          changeLangBus.$emit('changeLang');

          this.connect(
            "ws",
            `mallId=main&stationId=main`
          );

          setInterval(() => this.checkAliveSocket("ws", `mallId=main&stationId=main`), 15000);
        }
      }
    }
  },
  created() {
    changeLangBus.$on('changeLang', () => {
      this.storLang = localStorage.langType;
      const extenedLanguageArray = R.forEach(l => {
        l.altText = this.getName(l.name).name;
      }, this.$store.state.languages);
      this.$store.commit('setLanguages', extenedLanguageArray);
    });
  },
};
</script>
